import React from 'react';
import './ProjectCard.css';

const ProjectCard = ({
  screenshot,
  companyLogo,
  roleTitle,
  projectHeadline,
  projectDescription,
  tags,
  onClick
}) => {
  return (
    <div className="project-card clickable" onClick={onClick}>
      <div className="project-card-image">
        <img src={screenshot} alt="Project Screenshot" className="card-screenshot" />
      </div>
      <div className="project-card-content">
        {companyLogo && <img src={companyLogo} alt="Company Logo" className="card-company-logo" />}
        {roleTitle && <h3 className="card-role-title">{roleTitle}</h3>}
        <h2 className="card-project-headline">{projectHeadline}</h2>
        <p className="card-project-description">{projectDescription}</p>
        <div className="card-tags">
          {tags.slice(0, 3).map((tag, index) => (
            <span className="card-tag" key={index}>{tag}</span>
          ))}
          {tags.length > 3 && <span className="card-tag-more">+{tags.length - 3}</span>}
        </div>
        <div className="card-click-hint">Click to view details →</div>
      </div>
    </div>
  );
};

export default ProjectCard;